import { combineReducers } from 'redux'
import event from './event.reducer'
import security from './security.reducer'

export default combineReducers({
  event,
  security
})
